import { useEffect, useState } from "react";
import "./index.scss";
import Header from "./components/header";
import Map from "./components/map";
import { SelectModel } from "./components";
import { useResizeFont } from "../../hooks";
import { DataProvider } from "./data-context";
import sunImage from "@/assets/img/sun.png";
import compassImage from "@/assets/img/compass.png";
import addressNameImage from "@/assets/img/address-name.png";
import useData from "./useData";
import { enumAddressName } from "../../constants";
const MapPage = () => {
  const [tab, setTab] = useState(1); // 1镇级体育场所，2公共健身场所，3园区体育场所，4商圈体育门店，5居委综合活动室， 6学校运动场所
  const [visible, setVisible] = useState(true);
  useResizeFont();
  const bubbles = useData(enumAddressName[tab]);
  const selectOptions = useData(enumAddressName[5]);
  return (
    <DataProvider>
      <div className="map-page">
        <Header setTab={setTab} tab={tab} selectOptions={selectOptions} />
        <img src={compassImage} className="compassImage" alt="" />
        <img src={sunImage} className="sunImage" alt="" />
        <img src={addressNameImage} className="addressNameImage" alt="" />
        <Map tab={tab} initScale={1} rectWidth={120} isPC={true} bubbles={bubbles} />
        <SelectModel
          selectOptions={selectOptions}
          isPC={true}
          visible={visible}
          onCancel={() => {
            setVisible(false);
          }} />
      </div>
    </DataProvider>
  );
};

export default MapPage;
